/**
 * Util functions whose job is to save the landing information in cookies.
 */

import { Platform } from 'react-native'

import { isWeb } from '../isWeb'
import { Cookie } from './Cookie'
import type { TLandingInfo } from './landingInfos'

/**
 * Save the session info in cookies.
 *
 * @throws {Error} if not supported on this platform
 */
const saveSessionInfo = (sessionInfo: TLandingInfo) => {
  if (isWeb()) {
    Cookie.set('sessionInfo', JSON.stringify(sessionInfo), 'session')
  } else {
    console.error(`Cookie is not supported on this platform ${Platform.OS}`)
  }
}

/**
 * Get the session info from cookies.
 */
export const getSessionInfo = () => {
  if (isWeb()) {
    // oxlint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- JSON.parse stored value
    return JSON.parse(Cookie.get('sessionInfo') || 'null') as TLandingInfo | null
  } else {
    console.error(`Cookie is not supported on this platform ${Platform.OS}`)
    return null
  }
}

/**
 * Initialize the session info by storing the referrer, the current URL and the current date.
 * If some session info already exists, it will be merged with the new data.
 * This function should be called as soon as the app is loaded.
 */
export const initSessionInfo = () => {
  if (isWeb()) {
    const sessionInfo = getSessionInfo()

    saveSessionInfo({
      referrer: window.document.referrer,
      landingUrl: window.location.href,
      landingDate: new Date(),
      ...sessionInfo,
    })
  }
}
